import React from "react";
import {OverlayTrigger, Table, Tooltip} from "react-bootstrap";
import {AmpelPunkt, AMPEL_LABEL} from "./AmpelSelect.jsx";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {formatKw, formatMenge, lieferpositionStatusLabel} from "./format.js";
import {TOOLTIP_POPPER_CONFIG} from "./tooltipConfig.js";

/**
 * Geplante Zuläufe dieses Farbtons (PLAN.md Abschnitt 5) - eine Zeile je
 * Lieferposition mit KW Wunsch/Zusage/Ist, Mengen, Ampel (von Hand gesetzt
 * oder errechnet, PLAN.md Abschnitt 1b) und Status. Leere Liste verschwindet
 * vollständig.
 */
export default function ArtikelZulaeufeTabelle({zulaeufe}) {
    if (!zulaeufe || zulaeufe.length === 0) {
        return null;
    }

    return (
        <Table size="sm" hover responsive className="mb-0">
            <thead>
                <tr className="small text-muted">
                    <th>
                        <HeaderWithHelp help="Von Hand gesetzt oder importiert – nie errechnet, es sei denn, es fehlt eine Angabe (dann Rückfall, gekennzeichnet).">Ampel</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Kalenderwoche des ursprünglichen Bestellwunschs.">KW Wunsch</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Kalenderwoche, die Cosmos zugesagt hat.">KW Zusage</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Kalenderwoche der tatsächlichen Lieferung.">KW Ist</HeaderWithHelp>
                    </th>
                    <th className="text-end">
                        <HeaderWithHelp help="Ursprünglich gewünschte Menge.">Wunsch</HeaderWithHelp>
                    </th>
                    <th className="text-end">
                        <HeaderWithHelp help="Von Cosmos zugesagte Menge.">Zusage</HeaderWithHelp>
                    </th>
                    <th className="text-end">
                        <HeaderWithHelp help="Tatsächlich gelieferte Menge.">Ist</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Status der Lieferposition.">Status</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Die Lieferung, zu der diese Position gehört.">Lieferung</HeaderWithHelp>
                    </th>
                </tr>
            </thead>
            <tbody>
                {zulaeufe.map((z) => (
                    <tr key={z.id}>
                        <td>
                            <OverlayTrigger flip popperConfig={TOOLTIP_POPPER_CONFIG} placement="top" overlay={<Tooltip id={`zulauf-ampel-${z.id}`}>{z.ampel_herkunft === "gepflegt" ? "Von Hand gesetzt/importiert" : "Errechneter Rückfall (keine Ampel gepflegt)"}</Tooltip>}>
                                <span className="d-inline-flex align-items-center gap-1">
                                    <AmpelPunkt farbe={z.ampel} />
                                    <span className="small">{AMPEL_LABEL[z.ampel] || "–"}</span>
                                    {z.ampel_herkunft === "errechnet" && <span className="text-muted">*</span>}
                                </span>
                            </OverlayTrigger>
                        </td>
                        <td>{formatKw(z.kw_wunsch)}</td>
                        <td>{formatKw(z.kw_zusage)}</td>
                        <td>{formatKw(z.kw_ist)}</td>
                        <td className="text-end">{formatMenge(z.menge_wunsch)}</td>
                        <td className="text-end">{formatMenge(z.menge_zusage)}</td>
                        <td className="text-end">{formatMenge(z.menge_ist)}</td>
                        <td className="small">{lieferpositionStatusLabel(z.status)}</td>
                        <td className="small">{z.lieferung ? z.lieferung.lkw_bezeichnung || `#${z.lieferung.id}` : "–"}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
